<template>
    <div name="detail" class="detail" v-if="hospital === 0">
        <div class="detail" v-if="tab === 0" style="margin-bottom: calc(100vw * 120 / 375);">
            <img class="image" src="../../assets/showcase/xi/detail/common/medication/1.png" @click="goHistory"/>
            <img class="image" src="../../assets/showcase/xi/detail/common/medication/2_1.png" />
            <div class="wrapper">
                <img class="image" src="../../assets/showcase/xi/detail/hospital0/3.png" />
                <div class="button1">
                
                </div>
                <div class="button2" @click="goQuestionnaire">
            
                </div>
                <div class="button3" @click="goMedicine">
            
                </div>
                <!-- <div class="button4" @click="goMedicine">
    
                </div> -->
            </div>
            
            <img class="image" src="../../assets/showcase/xi/detail/hospital0/4.png" style="margin-top: -6px;" />
            <img class="image" src="../../assets/showcase/xi/detail/hospital0/5.png" @click="tabChange(4)"/>
            <img class="image" src="../../assets/showcase/xi/detail/hospital0/6.png" />
        </div>
        <div class="detail" v-else-if="tab === 1">
            <questionnaire 
                @goDetailTab="tabChange(0)"
                @goDeliveryTab="ttabChange(2)"
                @goMedicineTab="tabChange(3)"
                @goHistory="goHistory"
                :hospital="0"
            />
        </div>
        <div class="detail" v-else-if="tab === 2">
            <delivery
                @goDetailTab="tabChange(0)"
                @goQuestionnaireTab="tabChange(1)"
                @goMedicineTab="tabChange(3)"
                @goHistory="goHistory"
            />
        </div>
        <div class="detail" v-else-if="tab === 3">
            <ai-medication 
                @goDetailTab="tabChange(0)"
                @goQuestionnaireTab="tabChange(1)"
                @goDeliveryTab="tabChange(2)"
                @goHistory="goHistory"
                :hospital="0"
            />
        </div>
        <div class="detail" v-else-if="tab === 4">
            <document 
                @goDetailTab="tabChange(0)"
            />
        </div>
    </div>
    <div class="detail" v-else-if="hospital === 1">
        <div class="detail" v-if="tab === 0">
            <img class="image" src="../../assets/showcase/xi/detail/common/medication/1.png" @click="goHistory"/>
            <img class="image" src="../../assets/showcase/xi/detail/common/medication/2_2.png" />
            <div class="wrapper">
                <img class="image" src="../../assets/showcase/xi/detail/hospital1/3.png" />
                <div class="button1">
                
                </div>
                <div class="button2" @click="goQuestionnaire">
            
                </div>
                <div class="button3" @click="goMedicine">
            
                </div>
            </div>
            
            <img class="image" src="../../assets/showcase/xi/detail/hospital1/4.png" style="margin-top: -6px;" />
            <img class="image" src="../../assets/showcase/xi/detail/hospital1/5.png" @click="tabChange(4)"/>
            <img class="image" src="../../assets/showcase/xi/detail/hospital1/6.png" />
            <img class="image" src="../../assets/showcase/xi/detail/hospital1/7.png" />
        </div>
        <div class="detail" v-else-if="tab === 1">
            <questionnaire 
                @goDetailTab="tabChange(0)"
                @goDeliveryTab="tabChange(2)"
                @goMedicineTab="tabChange(3)"
                @goHistory="goHistory"
                :hospital="1"
            />
        </div>
        <div class="detail" v-else-if="tab === 2">
            <delivery-pharmacy 
                @goDetailTab="tabChange(0)"
                @goQuestionnaireTab="tabChange(1)"
                @goMedicineTab="tabChange(3)"
                @goHistory="goHistory"
            />
        </div>
        <div class="detail" v-else-if="tab === 3">
            <ai-medication 
                @goDetailTab="tabChange(0)"
                @goQuestionnaireTab="tabChange(1)"
                @goDeliveryTab="tabChange(2)"
                @goHistory="goHistory"
                :hospital="1"
            />
        </div>
        <div class="detail" v-else-if="tab === 4">
            <document 
                @goDetailTab="tabChange(0)"
            />
        </div>
        
    </div> 
</template>

<script>
import Questionnaire from '@/components/showcase/Questionnaire'
import DeliveryPharmacy from '@/components/showcase/DeliveryPharmacy';
import Delivery from '@/components/showcase/Delivery';
import AiMedication from '@/components/showcase/AiMedication.vue';
import Document from '@/components/showcase/Document';
export default {
  components: { Questionnaire, DeliveryPharmacy, AiMedication, Document, Delivery },
    name: 'detail',
    props: ['hospital', 'selectedTab'],
    data: function()
    {
        return {
            tab: 0      
        }
    },
    mounted: function()
    {
        this.tab = this.selectedTab
    },
    methods: {
        goHistory: function()
        {
            this.$emit('goHistory')
        },
        goQuestionnaire: function()
        {
            this.tab = 1;
            this.reset();
        },
        goDelivery: function()
        {
            this.tab = 2;
            this.reset();
        },
        goMedicine: function()
        {
            this.tab = 3;
            this.reset();
        },
        reset: function()
        {
            this.$emit('resetCount')
        },
        tabChange: function(tab)
        {
            this.tab = tab;
            this.reset();
        }
    }
}
</script>

<style scoped>
    .detail {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
    .image {
        width: 100%;
    }
    .wrapper {
        position: relative;
        width: 100%;
    }
 .button1 {
        position: absolute;
        width: 20%;
        aspect-ratio: 2/1.2;
        top: 0;
        left: 0;
        z-index: 1;
    }
     .button2 {
        position: absolute;
        width: 18%;
        aspect-ratio: 2/1.3;
        top: 0;
        left: 20%;
        z-index: 1;
    }
     .button3 {
        position: absolute;
        width: 15%;
        aspect-ratio: 2/1.6;
        top: 0;
        left: 38%;
        z-index: 1;
    }
     .button4 {
        position: absolute;
        width: 21%;
        aspect-ratio: 2/1.1;
        top: 0;
        left: 53%;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Detail.vue